<template>
  <div>
    <el-card shadow="never">
        <div class="custom-tree-container">
          <div class="block">
             <el-button
                    type="text"
                    size="mini"
                    @click="dialogVisible1 = true,setdata1()">
                    添加顶级分类
                  </el-button>
            <el-tree
              :data="data"
              node-key="id"
              default-expand-all
              :expand-on-click-node="false">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{ data.name }}</span>
                <span class="option-btn">
                  <el-button
                    type="text"
                    size="mini"
                    @click="dialogVisible1 = true,setdata(data)">
                    添加子分类
                  </el-button>
                  <el-button
                    type="text"
                    size="mini"
                    @click="dialogVisible = true,setinfo(data)">
                    编辑
                  </el-button>
                  <el-button
                    type="text"
                    size="mini"
                    @click="delClass(data)">
                    删除
                  </el-button>
                </span>
              </span>
            </el-tree>
          </div>
        </div>
    </el-card>
    <el-dialog title="添加子分类" :visible.sync="dialogVisible1" width="600px">
      <el-form ref="form" label-width="80px" style="width: 400px">
        <el-form-item label="分类名称">
          <el-input v-model="cname"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="orderby"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="addClass()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑子分类" :visible.sync="dialogVisible" width="600px">
      <el-form ref="form" label-width="80px" style="width: 400px">
        <el-form-item label="分类名称">
          <el-input v-model="cname"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="orderby"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editClass()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {


  data() {
    return {
      token: this.$cookies.get("shop_token"),
      data: [],
      cname:'',
      orderby: 0,
      dialogVisible1: false,
      dialogVisible: false,
      cid:0, //分类id
    };
  },
  created() {
    this.$store.state.shop_top = 1;
    this.$store.state.shop_left = "商品分类";
    this.getlist();
  },
  methods: {
    setdata1(){
       this.cid = 0; 
    },
    setdata(data){
       this.cid = data.id; 
    },
    setinfo (data){
      this.axios
      .get(this.$store.state.serve + "shop/getinfoClass", {
        params: {
          token: this.token,
          id:data.id,
        }
      })
      .then(res => {
        if (res.data.status == "success") {
          var data = res.data.data;
          this.cname = data.name;
          this.cid = data.id;
          this.orderby = data.order_by;
          console.log(this.orderby)
        }
      }); 
    },
    editClass () {
      this.axios
      .get(this.$store.state.serve + "shop/editClass", {
        params: {
          token: this.token,
          id:this.cid,
          name:this.cname,
          orderby: this.orderby,
        }
      })
      .then(res => {
        if (res.data.status == "success") {
           this.dialogVisible = false;
           window.location.reload();
        }
      }); 
    },
    addClass () {
      this.axios
      .get(this.$store.state.serve + "shop/addClass", {
        params: {
          token: this.token,
          id:this.cid,
          name:this.cname,
          orderby: this.orderby,
        }
      })
      .then(res => {
        if (res.data.status == "success") {
           this.dialogVisible1 = false;
           window.location.reload();
        }
      }); 
    },
    delClass(data){
      this.$confirm('此操作将永久删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          
          this.axios
            .get(this.$store.state.serve + "shop/delClass", {
              params: {
                token: this.token,
                id:data.id,
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                 this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                window.location.reload();
              }
            }); 
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      
    },
    getlist(){
      this.axios
        .get(this.$store.state.serve + "shop/getlistClass", {
          params: {
            token: this.token
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.data = res.data.data;
            console.log(res.data.data)
          }
      }); 
    }

    //   remove(node, data) {console.log(node.parent);
    //     const parent = node.parent;
    //     const children = parent.data.children || parent.data;
    //     const index = children.findIndex(d => d.id === data.id);
    //     children.splice(index, 1);
    //   }
    
  }
};
</script>
<style lang='scss'>
.option-btn{
   margin-left: 30px;
}
</style>